import { atom } from "recoil";
import { CustomerListDto } from "../services";

export const SelectedCustomerState = atom<CustomerListDto | null>({
  key: "selectedCustomerState",
  default: null,
});
